




















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const app = namespace("app");
const user = namespace("user");
@Component({})
export default class SideNav extends Vue {
  @app.State sideNavIndex;
  @app.Mutation setSideNavIndex;
  @user.State menuList;
  handleOpen() {}
  handleClose() {}
  showHoverNav: boolean = false;
  hoverIndex: number = 0;
  childrenNav: any[] = [];
  created() {
    this.matchSideActive();
  }
  // get navList() {
  //   return [
  //     { title: this.$t("layout.workbench"), iconName: "icon-workbench" },
  //     { title: this.$t("layout.server"), iconName: "icon-service" },
  //     { title: this.$t("layout.inventory"), iconName: "icon-inventory" },
  //     { title: this.$t("layout.purchase"), iconName: "icon-purchase" },
  //     { title: this.$t("layout.employee"), iconName: "icon-staff" },
  //     { title: this.$t("layout.finance"), iconName: "icon-finance" },
  //     { title: this.$t("layout.report"), iconName: "icon-report" },
  //     { title: this.$t("layout.marketing"), iconName: "icon-marketing" },
  //     { title: this.$t("layout.setting"), iconName: "icon-set" }
  //   ];
  // }
  meunKeyIndexMap: any = {
    workbench: 0,
    service: 1,
    setting: 2,
    inventory: 3,
    finance: 4,
    purchase: 6,
    marketing: 5
  };
  linkIndex() {
    this.$router.push("/");
  }
  matchSideActive() {
    let menuKey = this.$route.meta.menuKey;
    console.log(menuKey);
    menuKey && this.setSideNavIndex(this.meunKeyIndexMap[menuKey]);
  }
  hoverOneLevel(i, nav) {
    if (nav.children) {
      this.showHoverNav = true;
      this.hoverIndex = i;
      this.childrenNav = nav.children;
    } else {
      this.showHoverNav = false;
    }
  }
  linkNav(nav) {
    if (!nav.children) {
      this.$router.push(nav.pageUrl);
    }
  }
  handleSelectMenu(index) {
    this.showHoverNav = false;
    this.$router.push(index);
  }
  @Watch("$route.path")
  watchRoute(val) {
    this.matchSideActive();
  }
}
